import { IBaseDocumentUrl } from '../../../../core/interfaces/IBaseDocumentUrl'

export interface IBatchDocumentUrl extends IBaseDocumentUrl {
  partiallyGenerated: boolean;
}
